'use strict';

module.exports = function (ngModule) {
    // time object

    // id generator
    ngModule.service('generateId', require('./generateid'));

    // data fetcher
    ngModule.service('getData', require('./getdata'));
    ngModule.service('settings', require('./settings'));
    ngModule.service('fetchData', require('./fetchdata'));
    ngModule.service('fetchStream', require('./fetchstream'));

    // lane row symbol generator
    ngModule.factory('laneRowSymbols', require('./lanerowsymbols'));
    ngModule.factory('dictionary', require('./dictionary'));
    ngModule.factory('getSize', require('./getsize'));
    ngModule.factory('timeFormat', require('./timeformat'));
    ngModule.config(require('./spinnerconfig'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/services/index.js
 **/